import $ from 'jquery';

export default class Modal {
  constructor (el) {
    this.el = el;
  }

  init () {
    const that = this;

    $('[href="#' + this.id() + '"]').click(function () {
      that.open();
      return false;
    });

    $('.modal__overlay, .modal__close').click(() => this.close());
  }

  id () {
    return this.el.attr('id');
  }

  videoPreview(){
    return this.el.attr('video-preview');
  }

  open () {
    this.el.fadeIn('fast').addClass('modal--open').trigger('modal-open');
    $('.modal__overlay').fadeIn('fast');
    return false;
  }

  close () {
    if(this.id() =="postbox-modal"){
      if($('#emojikb-maindiv').css("display")!=="none"){
        $("#emoji-button").click();
      }
    }
    if(this.videoPreview() =="video-preview"){
      this.el.find(".modal__content").html("");
    }
    this.el.fadeOut('fast').removeClass('modal--open');
    $('.modal__overlay').fadeOut('fast');
    return false;
  }
}
